module.exports = __webpack_public_path__ + "media/flags/pa-1319a08f.svg";